import { toast } from "sonner";
import { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const ADMIN_LANGS = [
  { code: "de", name: "Deutsch" },
  { code: "en", name: "English" },
  { code: "pl", name: "Polski" },
  { code: "ru", name: "Русский" },
];

export function toML(value) {
  if (value && typeof value === "object") return { de: "", en: "", pl: "", ru: "", ...value };
  const s = value || "";
  return { de: s, en: s, pl: s, ru: s };
}

export function locRu(value) {
  if (value && typeof value === "object") return value.ru || value.de || Object.values(value).find(Boolean) || "";
  return value || "";
}

// 4-language text inputs bound to an object {de,en,pl,ru}
export function MLFields({ value, onChange, testid, label }) {
  const ml = toML(value);
  return (
    <div className="space-y-2">
      {label && <Label className="text-xs text-neutral-500">{label}</Label>}
      {ADMIN_LANGS.map((l) => (
        <div key={l.code} className="flex items-center gap-2">
          <span className="w-9 text-xs font-semibold uppercase text-neutral-400">{l.code}</span>
          <Input
            data-testid={`${testid}-${l.code}`}
            value={ml[l.code] || ""}
            onChange={(e) => onChange({ ...ml, [l.code]: e.target.value })}
            className="border-neutral-300 h-9"
            placeholder={l.name}
          />
        </div>
      ))}
    </div>
  );
}

export function SectionHeader({ title, description, action }) {
  return (
    <div className="flex items-start justify-between mb-6 gap-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description && <p className="text-sm text-neutral-500 mt-1">{description}</p>}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ text }) {
  return (
    <div className="border border-dashed border-neutral-300 rounded-lg py-14 text-center text-sm text-neutral-500">
      {text}
    </div>
  );
}

export function notifyError(err) {
  toast.error(apiError(err));
}
export function notifyOk(msg) {
  toast.success(msg);
}
